import { useState, useEffect } from 'react';
import { AuthData } from '../../Services/Authdata';
import {AdminDetail} from '../../Services/AdminLogin';

const useForm = (initialValues, callback, validate) => {

  const [values, setValues] = useState(initialValues)
  const [pass, setPass] = useState("");
	const [errors, setErrors] = useState({})
	const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
      
    if (errors !== undefined && Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }

  }, [errors]);

  const handleSubmit = (event) => {
    //console.log(values)
    if (event) event.preventDefault();
    AdminDetail('adminDetail/'+AuthData().id,'GET',AuthData().token).then((result)=>{
        setPass(result.data.password_original);
    })
    
      setErrors(validate(values,pass));
      setIsSubmitting(true);
 
  };

  const handleChange = (event) => {
    setValues(values => ({ ...values, [event.target.name]: event.target.type=='file'?event.target.files[0]:event.target.value }));
  };

  return {
    handleChange,
    handleSubmit,
    values,
    errors,
  }
};

export default useForm;


// WEBPACK FOOTER //
// ./src/Pages/Auth/useForm.js